/* eslint-disable no-unused-vars, no-dupe-keys, react/jsx-no-duplicate-props */
// This file is auto-generated by Simple. Edit AddressInput/view.blocks to change it.
import City from './City/index'
import React from 'react'
import State from './State/index'
import Street from './Street/index'
import UsePatient from './UsePatient/index'
import Zip from './Zip/index'
import viewPath from './viewPath.js'



/**
 * @type {(
 *  props: {
 *    [x: string]: any,
 *    children?: React.ReactNode,
 *    viewPath: typeof viewPath
 *  }) => React.JSX.Element}
 */
export default function AddressInput({
  children,
  viewPath = "/App/Widget/Content/Questions/Question/Content/AddressInput"
  
}) {
  return (<React.Fragment
>
<div
  data-testid="AddressInput.Vertical"
  data-view-path={viewPath}
 className="views-block"
>
<Street
  viewPath={`${viewPath}/Street`}
/>
<City
  viewPath={`${viewPath}/City`}
/>
<State
  viewPath={`${viewPath}/State`}
/>
<Zip
  viewPath={`${viewPath}/Zip`}
/>
<UsePatient
  viewPath={`${viewPath}/UsePatient`}
/>
</div>
{children}
</React.Fragment>)
}